export default __webpack_public_path__ + "static/media/Target-Animation.ce10a521.gif";